import { authApiService as i } from "@waitroom/common-api";
import { logout as s } from "./listener.es.js";
const f = (o) => ({
  ...o,
  mutationFn: async (r) => {
    const t = Intl.DateTimeFormat().resolvedOptions().timeZone, e = {
      ...r,
      email: r.email.toLowerCase(),
      timezone: t
    };
    return r.clientId && r.redirectUrl ? i.requestOAuthOTP({
      data: {
        ...e,
        redirect_uri: r.redirectUrl,
        client_id: r.clientId,
        state: r.state,
        codeChallenge: r.codeChallenge
      }
    }) : i.requestOTP({ data: e });
  }
}), l = (o) => ({
  ...o,
  mutationFn: async ({ email: r, otp: t, clientId: e, state: u, codeChallenge: n }) => e ? i.verifyOAuthOTP({
    data: {
      email: r.toLowerCase(),
      otp: t,
      client_id: e,
      state: u,
      codeChallenge: n
    }
  }) : i.verifyOTP({
    data: {
      email: r.toLowerCase(),
      otp: t
    }
  })
}), O = (o) => ({
  ...o,
  mutationFn: async ({
    token: r,
    code: t,
    type: e,
    userDetails: u,
    clientId: n,
    redirectUrl: a,
    state: d,
    codeChallenge: c
  }) => {
    if (!e || !t && !r) throw new Error("Invalid request");
    return n && a ? r ? i.verifyOAuthTokenProvider({
      data: {
        token: r,
        type: e,
        userDetails: u,
        client_id: n,
        redirect_uri: a,
        state: d,
        codeChallenge: c
      }
    }) : i.verifyOAuthCodeProvider({
      data: {
        code: t || "",
        type: e,
        client_id: n,
        redirect_uri: a,
        state: d,
        codeChallenge: c
      }
    }) : r ? i.verifyAuthTokenProvider({
      data: { token: r, type: e, userDetails: u }
    }) : i.verifyAuthCodeProvider({
      data: { code: t || "", type: e }
    });
  }
}), P = {
  mutationFn: s
};
export {
  P as logoutMutation,
  f as requestOTPMutation,
  O as verifyAuthProviderMutation,
  l as verifyOTPMutation
};
